export const CLUB_FACE_LABELS = {
    expert: {
        theme: 'SteelBlue',
        title: 'Эксперт клуба',
    },
    resident: {
        theme: 'oxfordBlue',
        title: 'Резидент клуба',
    },
};
